export default "__VITE_ASSET__B$uSAwlM__"